import type { BimPriceLevelEnum, BimWorkOrderTotalItemData, WorkOrderStatusEnum } from 'gql/graphql';

import type { AgGridReact } from 'ag-grid-react';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { BimWorkOrderTotalsTable } from '../../BimCommonComponents/BimWorkOrderTotalsTable';

import { useBimWorkOrderTotalsTable } from './hooks';

interface IBimWorkOrderTotalsTable {
    workOrderId: number;
    constructionTypeId: number | undefined;
    bimTotalsChapter: string;
    workOrderStatus: WorkOrderStatusEnum;
    hasInProgress: boolean;
    isFrameContract: boolean;
    priceLevel: BimPriceLevelEnum | undefined;
}

export const BimWorkOrderTotalsTableContainer = forwardRef(
    (
        {
            bimTotalsChapter,
            workOrderId,
            constructionTypeId,
            workOrderStatus,
            hasInProgress,
            isFrameContract,
            priceLevel,
        }: IBimWorkOrderTotalsTable,
        ref: ForwardedRef<AgGridReact<any>>,
    ) => {
        const { tableData } = useBimWorkOrderTotalsTable({
            bimTotalsChapter,
            workOrderId,
            constructionTypeId,
            priceLevel,
        });

        return (
            <BimWorkOrderTotalsTable<BimWorkOrderTotalItemData>
                tableData={tableData}
                workOrderStatus={workOrderStatus}
                hasInProgress={hasInProgress}
                isFrameContract={isFrameContract}
            />
        );
    },
);

BimWorkOrderTotalsTableContainer.displayName = 'BimWorkOrderTotalsTableContainer';
